/* eslint-disable prettier/prettier */
import { useState } from 'react'
import axios from 'axios'
import { baseApi } from './baseApi'
import { filters } from '../utils/connectionUtils'
import { useQuery } from '@tanstack/react-query'

export const useConnection = (enviroment) => {
  const [queryObject, setQueryObject] = useState({
    queryParams: [],
    searchParam: [],
    fiid: null,
    currentPage: 1,
    fetchData: true
  })

  const BASE_URL = baseApi(enviroment)

  const handlePagination = (e) => {
    setQueryObject({ ...queryObject, currentPage: e })
  }

  const apiConnection = ({
    geo,
    category,
    popularity,
    rating,
    price,
    name,
    pagination,
    uuid,
    fiid,
    offerType,
    priceLevel,
    businessType,
    predicateName,
    fetchData
  }) => {
    setQueryObject({ ...queryObject, fiid: fiid, currentPage: pagination })

    const queryParams = []
    const querySearch = []
    const query = filters(
      geo,
      category,
      offerType,
      enviroment,
      popularity,
      rating,
      price,
      priceLevel,
      businessType,
      predicateName,
      name
    )

    query.forEach((item) => {
      if (item.value === undefined || item.value.length === 0) {
        return undefined
      } else {
        queryParams.push(item.id)
      }
    })

    if (queryParams.includes('geo')) {
      querySearch.push(`&geo_payload=${geo}`)
    }

    if (queryParams.includes('category')) {
      querySearch.push(`&category_payload=${category}`)
    }

    if (queryParams.includes('offerType')) {
      querySearch.push(`&offerType_payload=${offerType}`)
    }

    if (queryParams.includes('recent')) {
      querySearch.push(`&recent_payload=${popularity}`)
    }

    if (queryParams.includes('popularity')) {
      querySearch.push(`&popularity_payload=${popularity}`)
    }

    if (queryParams.includes('rating')) {
      querySearch.push(`&rating_payload=${rating}`)
    }

    if (queryParams.includes('discountSort')) {
      querySearch.push(`&discountSort_payload=${price}`)
    }

    if (queryParams.includes('price')) {
      querySearch.push(
        `&price_payload=${enviroment !== 'legacy' ? priceLevel : price}`
      )
    }

    if (queryParams.includes('businessType')) {
      querySearch.push(`&businessType_payload=${businessType}`)
    }

    if (queryParams.includes('businessName')) {
      querySearch.push(`&businessName_payload=${predicateName}`)
    }

    if (name !== undefined) {
      querySearch.push(`&name=${name}`)
    }

    if (uuid !== undefined) {
      querySearch.push(`&uuid=${uuid}`)
    }

    // if (fiid !== undefined) {
    //   querySearch.push(`fiid=${fiid}`)
    // }
    setQueryObject({
      ...queryObject,
      queryParams: querySearch,
      searchParam: queryParams,
      fetchData,
      fiid: fiid
    })
  }

  const getOffersData = async ({ queryKey }) => {
    // validate if has filters if not ignores it
    // const COMPLETE_URL =
    //   queryKey[1].queryParams.length > 0
    //     ? `${BASE_URL}${`?filters=${queryKey[1].searchParam.join()}`}${queryKey[1].queryParams.join(
    //         ''
    //       )}&p=${queryKey[1].currentPage}&epp=0`
    //     : `${BASE_URL}?${queryKey[1].searchParam.join('')}&p=${
    //         queryKey[1].currentPage
    //       }&epp=0`
    let COMPLETE_URL
    // Validates if call has filters
    if (queryKey[1].queryParams.length > 0 && queryKey[1].searchParam.length > 0) {
      // validates if FI exist
      if (queryKey[1].fiid) {
        COMPLETE_URL = `${BASE_URL}${`?fiid=${queryKey[1].fiid}&filters=${queryKey[1].searchParam.join()}`}${queryKey[1].queryParams.join('')}&p=${queryKey[1].currentPage}&epp=0`
      } else {
        COMPLETE_URL = `${BASE_URL}${`?filters=${queryKey[1].searchParam.join()}`}${queryKey[1].queryParams.join('')}&p=${queryKey[1].currentPage}&epp=0`
      }
    } else {
    // validates if FI exist when there're no filters
      if (queryKey[1].fiid) {
        COMPLETE_URL = `${BASE_URL}?fiid=${queryKey[1].fiid}${queryKey[1].searchParam.join('')}&p=${queryKey[1].currentPage}&epp=0`
      } else {
        COMPLETE_URL = `${BASE_URL}?${queryKey[1].searchParam.join('')}&p=${queryKey[1].currentPage}&epp=0`
      }
    }

    const response = await axios({
      method: 'GET',
      url: COMPLETE_URL
    })
    const json = response.data
    return json
  }

  const { data, isLoading, isError, isSuccess } = useQuery(
    ['offersData', queryObject],
    getOffersData,
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      retry: 1,
      enabled: queryObject.fetchData
    }
  )

  const { queryParams, searchParam, currentPage } = queryObject

  return {
    apiConnection,
    handlePagination,
    isLoading,
    isError,
    currentPage,
    searchParam,
    queryParams,
    data,
    isSuccess
  }
}
